import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import api from './api';

// Components
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import RoadmapView from './components/RoadmapView';
import SyncManagement from './components/SyncManagement';
import SharedView from './components/SharedView';
import UserManagement from './components/UserManagement';
import MetadataManagement from './components/MetadataManagement';
import PresentationView from './components/PresentationView';
import StrategyHub from './components/StrategyHub';
import ReleasePlanning from './components/ReleasePlanning';
import UserProfile from './components/UserProfile';
import CapacityPlanning from './components/CapacityPlanning';
import AppShell from './components/AppShell';
import { AIChat } from './components/AIChat';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const userData = await api.getMe();
        setUser(userData);
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  };

  const handleLogin = async (userData) => {
    setUser(userData.user);
  };

  const handleLogout = () => {
    api.clearToken();
    setUser(null);
  };

  const handleUserUpdate = (updatedUser) => {
    setUser(updatedUser);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="flex flex-col items-center gap-4">
          <span className="upmap-logo upmap-logo-lg">u</span>
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-muted border-t-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />
        <Route path="/share/:token" element={<SharedView />} />
        <Route
          path="/roadmap/:id/present"
          element={user ? <PresentationView user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
        />
        {/* All authenticated routes use AppShell */}
        <Route
          path="/*"
          element={
            user ? (
              <AppShell user={user} onLogout={handleLogout} onUserUpdate={handleUserUpdate}>
                <Routes>
                  <Route path="/" element={<Dashboard user={user} onLogout={handleLogout} />} />
                  <Route path="/roadmap/:id" element={<RoadmapView user={user} onLogout={handleLogout} />} />
                  <Route path="/sync" element={<SyncManagement user={user} onLogout={handleLogout} />} />
                  <Route path="/users" element={<UserManagement user={user} onLogout={handleLogout} />} />
                  <Route path="/metadata" element={<MetadataManagement user={user} onLogout={handleLogout} />} />
                  <Route path="/strategy" element={<StrategyHub user={user} onLogout={handleLogout} />} />
                  <Route path="/releases" element={<ReleasePlanning user={user} onLogout={handleLogout} />} />
                  <Route path="/capacity" element={<CapacityPlanning user={user} />} />
                  <Route path="/profile" element={<UserProfile user={user} onUserUpdate={handleUserUpdate} />} />
                </Routes>
                <AIChat />
              </AppShell>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
